import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from '@fortawesome/fontawesome-svg-core'
import { Upload, message, Select, Input, Row, Col, Button, notification } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import GoogleMap from 'google-map-react';
import { apiRegisStore } from '../../services/api/register';
import { fas } from "@fortawesome/free-solid-svg-icons";
import 'antd/dist/antd.css';
import './style/store.scss';


library.add(fas);

const { Option } = Select;

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    // return isJpgOrPng && isLt2M;
    return false;
}

var lat;
var lng;


const mapStyles = {
    width: '100%',
    height: '100%'
}

const markerStyle = {
    height: '30px',
    width: '80px',
    marginTop: '-50px'
}

const imgStyle = {
    height: '100%'
}

const titleStyle = {
    fontSize: '14px',
    fontFamily: 'KanitRegular'
}
class User extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            imageUrl: undefined,
            latDefault: 13.736717,
            lngDefault: 100.523186,
            namestore: "",
            type_store: "",
            address: "",
            district: "",
            sub_district: "",
            province: "",
            zipcode: "",
            tel: "",
            email: "",
            username: "",
            password: "",
            repassword: "",
            img_store: []
        };
    }



    componentDidMount() {
        navigator.geolocation.getCurrentPosition(function (position) {
            lat = position.coords.latitude
            lng = position.coords.longitude

            console.log("Latitude is :", lat);
            console.log("Longitude is :", lng);
        });
    }


    changeMarker = (e) => {

        this.setState({
            latDefault: e.lat,
            lngDefault: e.lng
        })


    }

    regisStore = () => {
        if (this.state.password == this.state.repassword) {

            this.createStore();
        } else {
            notification.error({
                message: 'new message',
                description:
                    'password is not match.',
            });
        }
    }

    createStore = async () => {
        // console.log(this.state.type_store)
        var data = new FormData();
        data.append('image', this.state.img_store);
        data.append('name', this.state.namestore);
        data.append('merchant_type', this.state.type_store);
        data.append('address_no', this.state.address);
        data.append('district', this.state.district);
        data.append('sub_district', this.state.sub_district);
        data.append('province', this.state.province);
        data.append('post_code', this.state.zipcode);
        data.append('mobile', this.state.tel);
        data.append('email', this.state.email);
        data.append('username', this.state.username);
        data.append('password', this.state.password);
        data.append('loc_lat', this.state.latDefault);
        data.append('loc_lng', this.state.lngDefault);


        let resCreate = await apiRegisStore(data)
        if (resCreate && resCreate.status) {
            // console.log(resCreate)
            if (resCreate.status == 200) {
                Swal.fire({
                    title: 'Succcess!',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 1000
                })

                setTimeout(() => { window.location.href = "https://nippy-back.imsoftware.dev"}, 1000)

            } 
        }else{
            Swal.fire({
                title: 'Error!',
                text: resCreate.message,
                icon: 'error',
                showConfirmButton: false,
                timer: 1000
            })
        }
    }


    // getNameAddress = async (lat, lng) => {
    //     let res = await apiAddress(lat, lng)

    //     if (res && res.status) {
    //         if (res.status == 200) {
    //             console.log(res)

    //             this.setState({
    //                 nameAddress: res.data.results[0].formatted_address
    //             })
    //         } else {
    //             notification.error({
    //                 message: 'แจ้งเตือนใหม่',
    //                 description:
    //                     'กรุณาลองใหม่อีกครั้ง',
    //             });
    //         }
    //     }
    // }


    render() {

        const { loading, imageUrl } = this.state;
        const uploadButton = (
            <div>
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>อัพโหลดรูปภาพขนาด 350X200 พิกเซล</div>
            </div>
        );

        const Marker = ({ title }) => (
            <div style={markerStyle}>
                <img style={imgStyle} src="/img/icon/location.png" alt={title} />
                <h3 style={titleStyle}>{title}</h3>
            </div>
        );


        const handleChange = info => {
            const isLt2M = info.file.size / 1024 / 1024 < 2;

            if (
                isLt2M &&
                (info.file.type === "image/jpeg" ||
                    info.file.type === "image/png" ||
                    info.file.type === "image/jpg")
            ) {
                info.file.status = "done";
            } else {
                info.file.status = "error";
            }

            if (info.file.status === 'uploading') {
                this.setState({
                    loading: true
                })
                return;
            }

            if (info.file.status === "done") {
                info.fileList.map((image) => {
                    if (image.uid === info.file.uid) {
                        info.file.originFileObj = image.originFileObj;
                    }
                });
                // setImageUrl(info.file.originFileObj);
                getBase64(info.file.originFileObj, (imageUrl) => {
                    this.setState({
                        imageUrl,
                        img_store: info.file.originFileObj,
                        loading: false
                    })
                    // setImageUrl(imageUrl);
                    // setLoading(false);
                }

                );
            } else {
                this.setState({
                    loading: false
                })
            }
        };


        return (
            <div className="cover-create">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>

                <div className="box-create">
                    <div className="row half-box">
                        <div className="col-lg-4 col-md-4 col-12 col-img-store">
                            <div className="grid-ta">
                                <div className="box-ver">
                                    <div className="img-login">
                                        <img className="img-fluid" src="/img/pic/user.png" />
                                    </div>
                                    <div className="btn-create">
                                        <a className="link-create" type="button" href="/create_user">เปิดบัญชีผู้ซื้อ</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-12 col-register">
                            <div className="hd-des">
                                <a href="/auth" className="back-login"><FontAwesomeIcon icon={['fas', 'chevron-left']} /></a>
                                <p className="txt">สร้างบัญชีขายของ</p>
                            </div>

                            <div className="form-register">
                                <div className="data-regis">
                                    <div className="addimg">
                                        <Upload
                                            accept="image/*"
                                            name="avatar"
                                            listType="picture-card"
                                            className="avatar-uploader"
                                            showUploadList={false}
                                            // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                            beforeUpload={beforeUpload}
                                            onChange={handleChange}
                                        >

                                            {/* {console.log(imageUrl)} */}
                                            {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                                        </Upload>
                                    </div>
                                    <div className="name-store">
                                        <Input
                                            className="in-bx"
                                            onChange={(e) => { this.setState({ namestore: e.target.value }) }}
                                            placeholder="ชื่อร้าน" />
                                    </div>
                                    <div className="type-store">
                                        <Select className="in-bx" placeholder="กรุณาเลือกประเภท" style={{ width: '100%' }} onChange={(e) => {console.log(e);this.setState({type_store: e})}}>
                                            <Option value="DRINK">เครื่องดื่ม</Option>
                                            <Option value="SWEET">ของหวาน</Option>
                                            <Option value="SNACK">ของทานเล่น</Option>
                                            <Option value="DISH">อาหารคาว</Option>
                                            <Option value="SELL">ร้านขายของชำ</Option>
                                            <Option value="OTHER">อื่นๆ</Option>
                                        </Select>
                                    </div>
                                    <div className="name-store">
                                        <Input
                                            className="in-bx"
                                            onChange={(e) => { this.setState({ address: e.target.value }) }}
                                            placeholder="ที่อยู่" />
                                    </div>
                                    <div className="name-store">
                                        <Row gutter={[8, 8]}>
                                            <Col lg={8}>
                                                <Input
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ district: e.target.value }) }}
                                                    placeholder="อำเภอ" />
                                            </Col>
                                            <Col lg={8}>
                                                <Input
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ sub_district: e.target.value }) }}
                                                    placeholder="เขต" />
                                            </Col>
                                            <Col lg={8}>
                                                <Input
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ province: e.target.value }) }}
                                                    placeholder="จังหวัด" />
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="name-store">
                                        <Row gutter={[8, 8]}>
                                            <Col lg={8}>
                                                <Input
                                                    onChange={(e) => { this.setState({ zipcode: e.target.value }) }}
                                                    className="in-bx"
                                                    placeholder="รหัสไปรษณีย์" />
                                            </Col>
                                            <Col lg={16}>
                                                <Input
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ tel: e.target.value }) }}
                                                    placeholder="เบอร์มือถือ" />
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="name-store">
                                        <Row gutter={[8, 8]}>
                                            <Col lg={12}>
                                                <Input
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ email: e.target.value }) }}
                                                    placeholder="อีเมล" />
                                            </Col>
                                            <Col lg={12}>
                                                <Input
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ username: e.target.value }) }}
                                                    placeholder="ชื่อผู้ใช้" />
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="name-store">
                                        <Row gutter={[8, 8]}>
                                            <Col lg={12}>
                                                <Input.Password
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ password: e.target.value }) }}
                                                    placeholder="รหัสผ่าน" />
                                            </Col>
                                            <Col lg={12}>
                                                <Input.Password
                                                    className="in-bx"
                                                    onChange={(e) => { this.setState({ repassword: e.target.value }) }}
                                                    placeholder="ยืนยันรหัสผ่าน" />
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="map">
                                        <GoogleMap


                                            style={mapStyles}
                                            bootstrapURLKeys={{ key: 'AIzaSyC8bJru_qVoe0XgT1xmBD7rygLVUxq7FwY' }}
                                            center={{
                                                lat: this.state.latDefault,
                                                lng: this.state.lngDefault
                                            }}
                                            zoom={19}
                                            onClick={(e) => { this.changeMarker(e) }}
                                        >

                                            <Marker
                                                title={'current location'}
                                                lat={this.state.latDefault}
                                                lng={this.state.lngDefault}

                                            >
                                            </Marker>
                                        </GoogleMap>
                                    </div>

                                    <div className="btn-action">
                                        <Button onClick={() => { this.regisStore() }}>เปิดร้าน</Button>
                                    </div>
                                </div>

                                <p className="create-account">หรือ มีบัญชีอยู่แล้วและต้องการเข้าสู่ระบบ <a href="/auth" className="link-create">เข้าสู่ระบบ</a></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default User;
